import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../../../api/queryClient';
import {
  getV1BusinessPartnerCurrentSuggestIdentitiesOptions,
  getV1BusinessPartnerCurrentSuggestIdentitiesQueryKey,
} from '../../../api/generated/pap/@tanstack/react-query.gen';

/**
 * Query hooks for the invite flow (`InvitationModal`). See
 * `../../Settings/IdentityProviders/identityProviders.queries.ts` for the pattern.
 */

const SUGGESTION_MIN_CHARACTERS = 3;

/**
 * Identities that could be invited to the current Business Partner, filtered by the
 * local part of the email typed so far. Resolves to the `items` array.
 */
export const useSuggestedIdentities = (filter: string) => {
  const trimmedFilter = filter.split('@')[0].trim();
  return useQuery({
    ...getV1BusinessPartnerCurrentSuggestIdentitiesOptions({
      query: { suggest: trimmedFilter || undefined },
    }),
    select: (data) => data.items ?? [],
    enabled: trimmedFilter.length >= SUGGESTION_MIN_CHARACTERS,
  });
};

/** Clears every filter variant of the suggested-identities query. */
export const invalidateSuggestIdentities = () =>
  queryClient.invalidateQueries({
    queryKey: getV1BusinessPartnerCurrentSuggestIdentitiesQueryKey(),
  });
